/**
 * Raccourcis clavier de la review god : J = dossier suivant, K = dossier
 * précédent (même convention que la vue agence v2, `CarteGriseAgence`).
 * Ignorés dans un champ de saisie, avec un modificateur, ou quand une
 * fenêtre (modale CTVO, rejet…) est ouverte : la touche y a un autre sens.
 */
export type ReviewNavAction = 'next' | 'previous' | null;

export type ReviewNavKeyEvent = {
  key: string;
  metaKey?: boolean;
  ctrlKey?: boolean;
  altKey?: boolean;
  /** `tagName` de l'élément qui a le focus, ex. 'INPUT'. */
  targetTag?: string | null;
  targetEditable?: boolean;
  /** Une boîte de dialogue est ouverte dans la page. */
  dialogOpen?: boolean;
};

const CHAMPS_DE_SAISIE = /^(INPUT|TEXTAREA|SELECT)$/i;

export const resolveReviewNavKey = (e: ReviewNavKeyEvent): ReviewNavAction => {
  if (e.metaKey || e.ctrlKey || e.altKey) return null;
  if (e.dialogOpen) return null;
  if (e.targetEditable || (e.targetTag && CHAMPS_DE_SAISIE.test(e.targetTag))) return null;
  if (e.key === 'j' || e.key === 'J') return 'next';
  if (e.key === 'k' || e.key === 'K') return 'previous';
  return null;
};

/** Libellé court de la file de travail, pour « 3 / 12 · À reviewer ». */
export const libelleFileReview = (cgStatus: string | null | undefined): string => {
  switch (cgStatus) {
    case 'awaiting_review':
      return 'À reviewer';
    case 'awaiting_misiv':
      return 'Démarches ANTS';
    case 'awaiting_docs':
      return 'Pièces à déposer';
    case 'awaiting_reply':
      return 'Réponse attendue';
    case 'awaiting_payment':
      return 'Paiement attendu';
    case 'awaiting_docs_and_payment':
      return 'Pièces et paiement';
    case 'draft':
      return 'Brouillons';
    case 'completed':
      return 'Terminées';
    case 'rejected':
      return 'Rejetées';
    case 'cancelled':
      return 'Annulées';
    default:
      return cgStatus ?? 'Sans file';
  }
};
